<template lang="pug">
div(class="d-flex w-100 p-3 flex-column main-container overflow-auto" v-if="!loading && !error")
    div(class="d-flex w-100 d-flex mb-3 justify-content-between align-items-center")
        h2(v-if="!searchOpen" :class="{'slideInFromLeft': !searchOpen, 'slideOutFromLeft': searchOpen}") Invoices
        button(@click="openSearch" v-if="!searchOpen" :class="{'slideInFromRight': !searchOpen, 'slideOutToRight': searchOpen}")
            b-icon(icon="search")
        div(v-else class="search-group" :class="{'slideInFromRight': searchOpen, 'slideOutFromRight': !searchOpen}")
            b-input(v-model="searchID" placeholder="Search by ID")
            button(@click="closeSearch") 
                b-icon(icon="x")
    FowDepositCard(v-if="!searchOpen")
    div(class="d-flex p-2 w-100 tabs-container" v-if="!searchOpen")
        button(v-for="tab in tabs" :key="tab" @click="selectedTab = tab" :class="{'active': selectedTab === tab}") {{tab}}
    div(class="d-flex p-1 w-100" v-else)
        p.m-0 Search for invoice with ID: {{ searchID ? searchID : 'Start Typing' }}
    
    div(v-if="Object.keys(invoicesByMonth).length > 0")
        div(v-for="(invoices, month) in invoicesByMonth" :key="month" class="invoice-group mt-4 px-2")
            p.m-0(class="text-muted font-weight-light" style="font-size:0.9rem") {{ month }} 
            div(v-for="invoice in invoices" :key="invoice.name" class="invoice-item mt-2 d-flex justify-content-between align-items-center" @click="invoice?.guid ? goToInvoice(invoice.guid) : goToInvoice(invoice.crb5c_fow_paymentid)")
                div(class="d-flex align-items-center icon-container")
                    b-icon(icon="file-text")
                div(class="d-flex w-100 justify-content-between align-items-center text-container")
                    div(class="d-flex flex-column justify-content-between")
                        p.m-0(style="font-size:0.9rem") {{ invoice.id || invoice?.crb5c_reference }}
                        //- p.m-0(class="text-muted" style="font-size:0.8rem" v-if="selectedTab !== 'Adv Payments'")
                        //-     | {{ invoice.status === "Partial" || invoice.status === "Outstanding" ? 'Due' : invoice.status }} on {{ invoice.paidOrDueDate }}
                        p.m-0(class="text-muted" style="font-size:0.7rem" v-if="selectedTab === 'Adv Payments'")
                            | {{ checkValidDate(invoice) ? new Date(invoice.crb5c_receipt_date).toDateString() : 'Paid' }}

                    div(class="d-flex flex-column justify-content-between align-items-end")
                        p.m-0 ${{ getDisplayAmount(invoice) }}
                        p.m-0(class="text-small" :class="getStatusClass(invoice.status)")
                            | {{ invoice.status === "Partial" ? 'Due' : invoice.status }}


                        
                        
                
                div(v-if="selectedTab !== 'Deposits'")
                    b-icon(icon="arrow-right-circle")
    div(v-else class="d-flex w-100 h-100 flex-column align-items-center p-2 my-5")
        LottieAnimation(:animation-data="doggoData" :autoPlay="true" :loop="true" :speed="1" ref="anim" class="w-100")
        p.m-0 No Invoices Found
    div(class="w-100 h-auto d-flex font-weight-light justify-content-center align-items-center advance-payment-text" v-if="selectedTab === 'Adv Payments'")
        p.m-0 Advance payment not reflected? Please allow some time for it to process. If it still doesn't appear, contact admin for assistance.


div(class="d-flex w-100 h-100 flex-column align-items-center p-2" v-else-if="loading")
    b-skeleton(height="10vh" width="100%" class="my-2")
    div(class="tabs-skeleton w-100 d-flex" style="height: 50px;gap:5px;")
        b-skeleton(height="5vh" width="30%" class="my-2" v-for="i in 3")
    
    b-skeleton( height="10vh" width="100%" class="my-2" v-for="i in 3" )


div(class="d-flex w-100 h-100 flex-column align-items-center p-2" v-else-if="error")
    lottie-animation(:animation-data="animationData" :autoPlay="true" :loop="true" :speed="1" ref="anim" class="w-100")
    p(class="text-danger text-center") It's not you, it's us. Something went wrong. Please try again later
    b-button(@click="loadInvoices" variant="primary" class="mt-2") Try Again

</template>

<script>
import axios from 'axios';
import errorAnimation from '@/assets/errorAnimation.json';
import LottieAnimation from 'lottie-web-vue';
import doggoAnimation from '@/assets/doggo.json';
import FowDepositCard from '@/components/FowDepositCard.vue';

export default {
  components: { LottieAnimation, FowDepositCard },
  data() {
    return {
      tabs: ['Paid','Outstanding', 'All', 'Adv Payments'],
      loading: false,
      error: false,
      selectedTab: 'Outstanding',
      invoices: {},
      animationData: errorAnimation,
      searchOpen: false,
      searchID: '',
      doggoData: doggoAnimation
    };
  },
  computed: {
    filteredInvoices() {
    let tabKey = this.selectedTab === 'Adv Payments' ? 'adv_payments' : this.selectedTab.toLowerCase();
    let invoicesList = this.invoices[tabKey] || [];
      
      console.log(typeof invoicesList);
      console.log();
      if (this.searchID) {
        
        return invoicesList.filter(invoice => invoice.id.toString().toLowerCase().includes(this.searchID.toLowerCase()));
      }
    
      return invoicesList;
    },

    invoicesByMonth() {
        console.log(this.filteredInvoices);
      return this.filteredInvoices;
    }
  },
  methods: {
    checkValidDate(inv){
        return new Date(inv.crb5c_receipt_date).getFullYear() > 2015;
    },
    getDisplayAmount(invoice) {
        const total = invoice.amount && invoice.qty
            ? ((invoice.amount - (invoice?.subsidy || 0)) * invoice.qty * (1 + (invoice.gst || 0) / 100)).toFixed(2)
            : 0;

        if (this.selectedTab === 'Adv Payments') {
            return invoice?.crb5c_amountindollars;
        }

        if (this.selectedTab === 'Outstanding') {
            return invoice?.unpaidAmount;
        }

        if (this.selectedTab === 'All') {
            return invoice.status === 'Paid' ? total : invoice?.unpaidAmount;
        }

        return total;
    },
    getStatusClass(status) {
        return {
            'text-success': status === 'Paid',
            'text-danger': status === 'Outstanding' || status === 'Partial'
        };
    },
    openSearch() {
      this.searchOpen = true;
      this.selectedTab = 'All';
    },
    closeSearch() {
      this.searchOpen = false;
      this.searchID = '';
    },
    goToInvoice(id) {
        if(this.selectedTab === 'Adv Payments') {
            this.$router.replace(`/invoice_single?id=${id}&adv=true`);
        }
        else{
        this.$router.replace(`/invoice_single?id=${id}`);
        }
    },
    async loadCurrentUser() {
      while (!this.$root.currentUser[0]) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    },
    async loadInvoices() {
      try {
        this.loading = true;
        await this.loadCurrentUser();
        const clientID = this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid;
        if (!clientID) return;
        const { data } = await axios.get(`/api/invoices/${clientID}`);
        this.invoices = data.data;
        console.log(this.invoices);
      } catch (error) {
        this.error = true;
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    await this.loadInvoices();
  }
};
</script>

<style lang="scss" scoped>
.main-container{
    height: 90vh;
    overflow-y: auto;
}
.tabs-container{
    width: 100%;
    border-radius: 0.8rem;
    background-color: #EDEEF2;
    gap: 1rem;
    
    button{
        width: 100%;
        height: 65px;
        background-color: #EDEEF2;
        border: none;
        border-radius: 0.8rem;
        cursor: pointer;
        transition: background-color 0.3s;
        font-size: small;
        
    }
    .active{
        background-color: white;
    }    
}
button{
    outline: none;
    background-color: #EDEEF2;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    width: 10%;
    border-radius: 0.4rem;
    color: black;
}
.invoice-item{
    background-color: white;
    border-radius: 0.5rem;
    height: 65px;
    gap: 1rem;
    .icon-container{
        width: 15%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #EDEEF2;
        border-radius: 0.5rem;
        b-icon{
            font-size: 1.5rem;
        }
    }
    .text-container{
        width: 85%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        div{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 0.5rem;
        }
    }
}
.text-small{
    font-size: 0.8rem;
}
.advance-payment-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 0.85rem;
    text-align: center;
    padding: 0.5rem;
    box-sizing: border-box;
    overflow-x: hidden;
}



@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}
@keyframes slideOutToRight {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(100%);
    }
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
}
@keyframes slideOutToLeft {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

.slideOutToRight{
    animation: slideOutToRight 0.5s;
}



.slideInFromRight{
    animation: slideInFromRight 0.5s;
}

.slideInFromLeft{
    animation: slideInFromLeft 0.5s;
}

.slideOutToLeft{
    animation: slideOutToLeft 0.5s;
}
.search-group{
    width: 100%;
    display: flex;
    gap: 0.5rem;
    b-input{
        width: 80%;
        height:100%;
    }
    button{
        width: 20%;
    }
}
</style>